module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_icon_11.f0bcd704.png";